SupportLocationListTemplate = require '../../../../location_list_view.html.mustache'
EmailFormUSLocationListRowView = require './location_list_row_view'
EmailFormUSLocationSelectPaginationView = require "./location_select_pagination"
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormUSLocationListView extends Backbone.View
  id: 'popupContent'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportLocationListTemplate
    @locations = Groupon.Support.currentOrder.dealOption.redemptionLocations
    @noOfItemsPerPage = 15
    @startIndex = 0
    @render()
    @renderLocations()
    @paginationView = new EmailFormUSLocationSelectPaginationView
      paginationElement : $(@el).find('div#locationPagination')
      itemsPerPage: @noOfItemsPerPage
      totalNoOfItems : @locations.length
      callback : @paginationClickHandler
    @renderPagination()
    @popup = $("#popup")
    GIG.Modal.open
      el: @popup
      closeOnBgClick: true
      closeOnEscKey: true
    @popup.html(this.el)


  render: ->
    @renderHeaderAndFooter()
    # Pagination to be called only after its required divs have been rendered

  renderPagination: ->
    @paginationView.render()

  renderHeaderAndFooter: ->
    @$el.html toHtml(@template, {}, @I18nScope)

  renderLocations: ->
    locationsTable = $(@el).find('table#locationsTable')
    locationsTable.empty()
    startIndex = @startIndex * @noOfItemsPerPage
    endIndex = startIndex + @noOfItemsPerPage - 1
    endIndex = @locations.length-1 if endIndex > (@locations.length - 1)
    rowElements = []
    elementsPushedIntoRow = 0
    for index in [startIndex..endIndex] by 1
      obj = @locations[index]
      obj.id = index
      rowElements[elementsPushedIntoRow] = obj
      elementsPushedIntoRow += 1
      if elementsPushedIntoRow == 3 || index == endIndex
        row = new EmailFormUSLocationListRowView
          elements: rowElements
        locationsTable.append(row.el)
        row.render()
        elementsPushedIntoRow = 0
        rowElements = []

  paginationClickHandler: (newPageIndex, paginationContainer) ->
    @startIndex = newPageIndex
    @renderLocations()
    return false

  finishChoosingLocations: ->
    GIG.Modal.close()
    for location in Groupon.Support.currentOrder.dealOption.redemptionLocations
      location.isSelected = location.isMarked
    @options.cb.call()
    return false

  cancelChoosingLocations: ->
    GIG.Modal.close()
    return false


  events :
     "click #btnsubmit"      : "finishChoosingLocations"
     "click #cancelLocationSelect"  : "cancelChoosingLocations"
     'click .close-modal' : "cancelChoosingLocations"

module.exports = EmailFormUSLocationListView
